import angular from 'angular';
import DataBrowserService from './dataBrowserService.service';

let DataBrowserServiceModule = angular.module('dataBrowserService', []).service('dataBrowserService', DataBrowserService);

export
default DataBrowserServiceModule;


// WEBPACK FOOTER //
// ./app/common/dataBrowserService/dataBrowserService.js